import { render } from "./CostListByWsxy.vue?vue&type=template&id=6bf7eb36&scoped=true"
import script from "./CostListByWsxy.vue?vue&type=script&lang=js"
export * from "./CostListByWsxy.vue?vue&type=script&lang=js"

import "./CostListByWsxy.vue?vue&type=style&index=0&id=6bf7eb36&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6bf7eb36"

export default script